export type ReelCaption = { text: string; startMs: number; endMs: number };
export function parseReelCaptions(input: string, durationMs: number): ReelCaption[] {
  if (input.length > 100000 || !Number.isFinite(durationMs) || durationMs <= 0)
    throw new Error('Choose an SRT file under 100 KB and a readable Reel.');
  const blocks = input
    .replace(/^\uFEFF/, '')
    .replace(/\r\n?/g, '\n')
    .trim()
    .split(/\n\s*\n/);
  if (blocks.length > 50) throw new Error('Use at most 50 captions.');
  const results: ReelCaption[] = [];
  for (const block of blocks) {
    const lines = block.split('\n');
    if (/^\d+$/.test(lines[0] ?? '')) lines.shift();
    const match =
      /^(\d{2}):([0-5]\d):([0-5]\d),(\d{3})\s+-->\s+(\d{2}):([0-5]\d):([0-5]\d),(\d{3})$/.exec(
        lines.shift() ?? '',
      );
    const text = lines.join('\n').trim();
    if (!match || !text || text.length > 300)
      throw new Error(
        'Check the SRT timestamps and keep each caption between 1 and 300 characters.',
      );
    const time = (offset: number) =>
      Number(match[offset]) * 3600000 +
      Number(match[offset + 1]) * 60000 +
      Number(match[offset + 2]) * 1000 +
      Number(match[offset + 3]);
    const startMs = time(1),
      endMs = time(5);
    if (startMs >= endMs) throw new Error('Each caption must end after it starts.');
    if (startMs < durationMs) results.push({ text, startMs, endMs: Math.min(endMs, durationMs) });
  }
  if (!results.length)
    throw new Error(
      'No captions fall inside this Reel. Caption times start at the Reel’s beginning.',
    );
  return results;
}
